<template>
  <div class="import-file-dialog">
    <el-dialog
      :visible.sync="importVisible"
      title="导入价格"
      width="40%"
    >
      <el-form :rules="formRules" :model="params" label-width="100px">
        <el-form-item
          prop="dataFileId"
          label="数据文件"
          style="margin-top: 30px"
        >
          <file-upload
            ref="dataFileUpload"
            :upload-param="{ filePath: 'temp' }"
            show-type="text"
            @uploaded="getDataFile"
            @removed="clearDataFile"
          >
            <el-button
              type="primary"
              class="primary sold-out"
              size="small"
              >点击上传</el-button
            >
          </file-upload>
        </el-form-item>
        <el-form-item label="模板文件">
          <a :href="templateFile" target="_blank">点击下载模板文件</a>
        </el-form-item>
      </el-form>
      <el-row>
        <el-col :offset="2" :span="16">
          <p v-for="(error, index) in errorList" :key="index">{{ error }}</p>
        </el-col>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button :loading="!canImport" type="primary" @click="handleImport">{{
          canImport ? "导入价格" : "导入中"
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FileUpload from '@/components/file-upload'
import bccApi from '@/api/bcc'
export default {
  name: 'ImportFileDialog',
  components: {
    FileUpload
  },
  data () {
    return {
      errorList: [],
      importVisible: false,
      templateFile: require('@/assets/files/import-item-price-region.xlsx'),
      canImport: true,
      formRules: {
        dataFileId: [
          { required: true, message: '请上传数据文件', trigger: 'change' }
        ]
      },
      params: {
        dataFileId: ''
      }
    }
  },
  watch: {
    importVisible (val) {
      if (val === false) {
        this.reset()
      }
    }
  },
  created () {},
  methods: {
    show () {
      this.importVisible = true
    },

    // 上传文件
    getDataFile (file) {
      this.params.dataFileId = file.fileId
    },
    // 删除文件
    clearDataFile (file) {
      this.params.dataFileId = ''
      this.errorList = []
    },
    // 检查条件
    check () {
      if (!this.params.dataFileId) {
        this.$message.error('请上传文件')
        return false
      }
      return true
    },
    // 导入文件
    handleImport () {
      if (!this.check()) {
        return
      }
      this.canImport = false
      bccApi
        .importTtradeItemPriceRegion(this.params)
        .then((res) => {
          if (res.data.resultCode === '0') {
            this.$message.success('导入成功')
            // this.$emit('successImport')
            this.reset()
            this.importVisible = false
          } else {
            if (res.data.resultData && res.data.resultData.errorList) {
              this.errorList = res.data.resultData.errorList
            }
          }
          this.canImport = true
        })
        .catch(() => {
          this.$message.error('导入失败')
          this.canImport = true
        })
    },
    close () {
      this.importVisible = false
      this.reset()
    },
    // 重置
    reset () {
      this.params = this.$options.data().params
      this.templateFile = ''
      this.errorList = []
      this.$refs.dataFileUpload.getClearFiles()
    }
  }
}
</script>

<style lang="scss" scoped>
a,
a:link,
a:visited,
a:hover {
  color: #409eff;
}
.dialog-footer {
  .el-button {
    width: 100px !important;
  }
}
</style>
